import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import InactiveAccountNotice from './InactiveAccountNotice';
import './Form.css';

const LoginForm = ({ setAuth }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [captchaAnswer, setCaptchaAnswer] = useState('');
  const [captchaQuestion, setCaptchaQuestion] = useState('');
  const [captchaToken, setCaptchaToken] = useState('');
  const [message, setMessage] = useState('');
  const [showInactiveNotice, setShowInactiveNotice] = useState(false);
  const navigate = useNavigate();

  // Falls der Benutzer bereits eingeloggt ist, wird direkt weitergeleitet.
  useEffect(() => {
    if (localStorage.getItem('token')) {
      setMessage('Bereits eingeloggt. Weiterleitung zur Hauptseite...');
      setTimeout(() => navigate('/'), 1500);
    }
  }, [navigate]);

  // Fetch captcha challenge when component mounts or when refreshed.
  useEffect(() => {
    fetch('/api/captcha')
      .then((response) => response.json())
      .then((data) => {
        setCaptchaQuestion(data.question);
        setCaptchaToken(data.token);
      })
      .catch((err) => console.error('Error fetching captcha:', err));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    try {
      const response = await fetch('/api/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password, captchaAnswer, captchaToken })
      });
      const data = await response.json();
      
      // Prüfe auf inaktives Konto
      if (response.status === 403 && data.accountDeactivated) {
        setShowInactiveNotice(true);
        return;
      }
      
      if (!response.ok) {
        setMessage(data.error || 'Login fehlgeschlagen');
      } else {
        // Token und User-Daten speichern
        localStorage.setItem('token', data.token);
        localStorage.setItem('user', JSON.stringify(data.user));
        setMessage(`Login erfolgreich! Willkommen, ${data.user.username}`);
        setPassword(''); // Passwort-Feld leeren
        setAuth(true);   // Aktualisierung des globalen Auth-Status
        setTimeout(() => navigate('/'), 1500);
      }
    } catch (error) {
      console.error('Login error:', error);
      setMessage('Fehler während des Logins.');
    } finally {
      // Optionally, fetch a new captcha challenge after each login attempt.
      fetch('/api/captcha')
        .then((response) => response.json())
        .then((data) => {
          setCaptchaQuestion(data.question);
          setCaptchaToken(data.token);
        })
        .catch((err) => console.error('Error fetching captcha:', err));
      setCaptchaAnswer('');
    }
  };

  const handleCloseInactiveNotice = () => {
    setShowInactiveNotice(false);
  };

  return (
    <>
      <div className="login-form" style={{ maxWidth: '400px', margin: '2rem auto' }}>
        <h1>Login</h1>
        {message && (
          <div className="message" style={{ marginBottom: '1rem', color: '#d8000c' }}>
            {message}
          </div>
        )}
        <form onSubmit={handleSubmit}>
          <div className="form-group" style={{ marginBottom: '1rem' }}>
            <label htmlFor="email" style={{ display: 'block', marginBottom: '0.5rem' }}>
              E-Mail
            </label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={{ width: '100%', padding: '0.5rem', boxSizing: 'border-box' }}
            />
          </div>
          <div className="form-group" style={{ marginBottom: '1rem' }}>
            <label htmlFor="password" style={{ display: 'block', marginBottom: '0.5rem' }}>
              Passwort
            </label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={{ width: '100%', padding: '0.5rem', boxSizing: 'border-box' }}
            />
          </div>
          {captchaQuestion && (
            <div className="form-group" style={{ marginBottom: '1rem' }}>
              <label style={{ display: 'block', marginBottom: '0.5rem' }}>{captchaQuestion}</label>
              <input
                type="text"
                id="captchaAnswer"
                value={captchaAnswer}
                onChange={(e) => setCaptchaAnswer(e.target.value)}
                required
                placeholder="Antwort hier eingeben"
                style={{ width: '100%', padding: '0.5rem', backgroundColor: '#ff5733', boxSizing: 'border-box' }}
              />
            </div>
          )}
          <button
            type="submit"
            className="btn-submit"
            style={{
              width: '100%',
              padding: '0.75rem',
              background: '#007bff',
              color: 'white',
              border: 'none',
              cursor: 'pointer'
            }}
          >
            Einloggen
          </button>
        </form>
        
        <div className="password-recovery" style={{ marginTop: '20px', textAlign: 'center' }}>
          <a href="/forgot-password" style={{ color: '#007bff', textDecoration: 'none' }}>
            Passwort vergessen?
          </a>
        </div>
      </div>
      
      {showInactiveNotice && (
        <InactiveAccountNotice onClose={handleCloseInactiveNotice} />
      )}
    </>
  );
};

export default LoginForm;